import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {BdListLink, DictionaryLink, LanguageLaboratoryLink, MindmapListLink, NotepadListLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const LearnerToolsGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.tools',
    links: [
        // DictionaryLink(context),
        // LanguageLaboratoryLink(context)
        NotepadListLink(context),
        MindmapListLink(context),
        BdListLink(context)
    ],
    icon: 'navigation-group__tools',
});